import axios from "axios";

export default {
  namespaced: true,
  state: {
    inventoryjournals: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    inventoryjournalsMessage: ''
  },
  mutations: {
    CLEAR_INVENTORYJOURNALS(state) {
      state.inventoryjournals = [];
    },
    RECEIVED_INVENTORYJOURNALS(state, payload) {
      state.inventoryjournals = payload;
      state.isReceiving = false;
    },
    RECEIVED_INVENTORYJOURNAL(state, payload) {
      let find = state.inventoryjournals.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { inventoryjournals: [payload, ...state.inventoryjournals] });
      }
      else {
        let index = state.inventoryjournals.findIndex(i => i._id === payload._id);
        state.inventoryjournals.splice(index, 1, payload);
      }
    },
    RECEIVING_INVENTORYJOURNALS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_INVENTORYJOURNAL(state) {
      state.isReceiving = true;
    },
    UPDATED_INVENTORYJOURNAL(state, payload) {
      console.log(state.inventoryjournals);
      console.log(payload);
      let index = state.inventoryjournals.findIndex(inventoryjournal => inventoryjournal._id === payload._id);
      state = Object.assign(state, {
        inventoryjournals: state.inventoryjournals.map((inventoryjournal, i) => {
          if (i === index) {
            return Object.assign({}, inventoryjournal, payload);
          }
          return inventoryjournal;
        }),
        isUpdating: false,
        inventoryjournalsMessage: 'InventoryJournals has been updating!',
      })
    },
    UPDATING_INVENTORYJOURNAL(state) {
      state.isUpdating = true;
    },
    DELETED_INVENTORYJOURNAL(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.inventoryjournals.findIndex(inventoryjournal => inventoryjournal._id === payload._id);
      console.log(indexToDelete);
      let inventoryjournals = [...state.inventoryjournals];
      inventoryjournals.splice(indexToDelete, 1);
      state = Object.assign(state, {
        inventoryjournals: [...inventoryjournals],
        isDeleting: false,
        idToDelete: null,
        inventoryjournalsMessage: 'InventoryJournal has been Deleted!',
      });
    },
    DELETING_INVENTORYJOURNAL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteInventoryJournalRequest({dispatch}, payload) {
      dispatch("deletingInventoryJournal", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/inventoryjournal/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteInventoryJournal", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteIVJTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/ivjtransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertInventoryJournalRequest({dispatch}, payload) {
      dispatch("receivingInventoryJournals");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/inventoryjournal';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveInventoryJournal", response.data);
    },
    async insertIVJTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/ivjtransaction/" + payload.journalid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getInventoryJournalsRequest({dispatch}) {
      dispatch("receivingInventoryJournals");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/inventoryjournals';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(res => {
        console.log(token)
        dispatch("receiveInventoryJournals", res.data);
      })
    },
    async getInventoryJournalRequest({dispatch}, id) {
      dispatch("receivingInventoryJournals");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/inventoryjournal/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: headers})
      .then(response => {
        dispatch("receiveInventoryJournal", response.data);
      })
    },
    async findInventoryJournalsRequest({dispatch}, payload) {
      try{
        dispatch("receivingInventoryJournals");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/inventoryjournals';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveInventoryJournals", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateInventoryJournalRequest({dispatch}, payload) {
      dispatch("updatingInventoryJournal");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/inventoryjournal/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateInventoryJournal", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateIVJTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingInventoryJournal");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/ivjtransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingInventoryJournal", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    clearInventoryJournals({commit}) {
      commit("CLEAR_INVENTORYJOURNALS")
    },
    receiveInventoryJournals({commit}, payload) {
      commit("RECEIVED_INVENTORYJOURNALS", payload)
    },
    receiveInventoryJournal({commit}, payload) {
      commit("RECEIVED_INVENTORYJOURNAL", payload)
    },
    receivingInventoryJournals({commit}) {
      commit("RECEIVING_INVENTORYJOURNALS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivingInventoryJournal({commit}) {
      commit("RECEIVING_INVENTORYJOURNAL")
    },
    updateInventoryJournal({commit}, payload) {
      commit("UPDATED_INVENTORYJOURNAL", payload)
    },
    updatingInventoryJournal({commit}) {
      commit("UPDATING_INVENTORYJOURNAL")
    },
    deleteInventoryJournal({commit}, payload) {
      commit("DELETED_INVENTORYJOURNAL", payload)
    },
    deletingInventoryJournal({commit}, payload) {
      commit("DELETING_INVENTORYJOURNAL", payload)
    }
  },
};
